// import mockData from './mockData'
import axios from 'axios'
import XLSX from 'xlsx'
import { mapState, mapActions, mapGetters } from 'vuex'
import TextFormatting from '@/mixins/reusable_mixins/TextFormatting'
import BranchOfficeService from '@/services/api/branchOffice'

//
import SlGroundSellerSaleCommissionModel from '@/models/Sale/SlGroundSellerSaleCommission'

export default {
    data() {
        return {
            date: '',
            date2: '',
            showCalendar: false,
            showCalendar2: false,
            items: [],
            showing: 0,
            showModal: true,
            showList: false,
            loading: false,
            branchOfficeName: '',
            branchOfficeList: [],
            branchOfficeSelected: null,
        }
    },
    computed: {
        showItems() {
            switch (this.showing) {
                case 0:
                    return this.items
                case 1:
                    return this.showTickets
                case 2:
                    return this.showInvoices
                case 3:
                    return this.showTBK
                case 4:
                    return this.showChecks
                case 5:
                    return this.showCustomerCredit
                //case 6:
                //return this.showInternalConsumption
                case 7:
                    return this.showEmployeeSales
                case 8:
                    return this.items
                default:
                    return this.items
            }
        },
        reportName() {
            switch (this.showing) {
                case 0:
                    return 'COMPLETO'
                case 1:
                    return 'BOLETAS'
                case 2:
                    return 'FACTURAS'
                case 3:
                    return 'TRANSBANK'
                case 4:
                    return 'CHEQUES'
                case 5:
                    return 'CREDITO_CLIENTE'
                case 6:
                    return 'CONSUMO_INTERNO'
                case 7:
                    return 'VENTA_EMPLEADO'
                case 8:
                    return 'NOTA_CREDITO'
                case 9:
                    return 'INGRESO_EGRESO'
                case 10:
                    return 'VENDEDORES_TERRENO'
                default:
                    return 'COMPLETO'
            }
        },
        showTickets() {
            return this.items.filter(i => i.tipo === 'BOLETA')
        },
        showInvoices() {
            return this.items.filter(i => i.tipo === 'FACTURA')
        },
        showTBK() {
            return this.items.filter(i =>
                ['DÉBITO', 'CRÉDITO'].includes(i.medio_de_pago)
            )
        },
        showChecks() {
            return this.items.filter(i =>
                ['CHEQUE A FECHA', 'CHEQUE AL DÍA'].includes(i.medio_de_pago)
            )
        },
        showInternalConsumption() {
            //this.items[0].tipo_transaccion = "CONSUMO INTERNO"
            return this.items.filter(
                i => i.tipo_transaccion === 'CONSUMO INTERNO'
            )
        },
        showEmployeeSales() {
            // this.items[1].tipo_transaccion = "VENTA EMPLEADO"
            // this.items[2].tipo_transaccion = "VENTA EMPLEADO"
            // this.items[3].tipo_transaccion = "VENTA EMPLEADO"

            return this.items.filter(
                i => i.tipo_transaccion === 'VENTA EMPLEADO'
            )
        },
        showCustomerCredit() {
            return this.items.filter(i =>
                ['CRÉDITO CLIENTE'].includes(i.medio_de_pago)
            )
        },
        calcTotal() {
            return this.showItems.reduce((total, item) => {
                return total + item.total
            }, 0)
        },
        calcPaymentMethodTotal() {
            return this.showItems.reduce((total, item) => {
                return total + item.monto_medio_de_pago
            }, 0)
        },
        printData() {
            let data = []
            let cols = this.headers.map(h => {
                return { name: h.text, key: h.text }
            })
            data[0] = cols.map(col => col.name)
            this.showItems.forEach(item => {
                let row = []
                this.iterator.forEach(h => {
                    row.push(item[h])
                })
                data.push(row)
            })
            let totals = cols.map(c => {
                let val = ''
                switch (c.name) {
                    case 'TOTAL':
                        val = this.calcTotal
                        break
                    case 'MONTO MEDIO DE PAGO':
                        val = this.calcPaymentMethodTotal
                        break
                }
                return val
            })
            data.push(totals)
            return { cols, data }
        },
        iterator() {
            return this.headers.map(h => {
                if (h.text === 'FECHA/HORA') return 'fecha_hora_venta'
                if(h.text === 'FECHA COBRO') return 'fecha_que_debe_pagar'
                if (h.text === 'N° CAJA') return 'num_caja'
                return this.lowerAndUnderscore(h.text)
            })
        },
        excludeHeaders() {
            switch (this.showing) {
                case 0:
                    return ['ENTIDAD FOLIO','FECHA COBRO']
                case 1:
                    return [
                        'TIPO',
                        'RUT CLIENTE',
                        'RAZON SOCIAL CLIENTE',
                        'ENTIDAD FOLIO',
                        'FECHA COBRO',
                    ]
                case 2:
                    return ['TIPO', 'ENTIDAD FOLIO','FECHA COBRO']
                case 3:
                    return ['ENTIDAD FOLIO','FECHA COBRO']
                case 4:
                    return ['ENTIDAD FOLIO']
                case 5:
                    return ['ENTIDAD FOLIO','FECHA COBRO']
                case 6:
                    return ['ENTIDAD FOLIO','FECHA COBRO']
                case 7:
                    return ['ENTIDAD FOLIO','FECHA COBRO']
                case 8:
                    return [
                        'ESTADO',
                        'MEDIO DE PAGO',
                        'MONTO MEDIO DE PAGO',
                        'FECHA/HORA',
                        'FECHA COBRO',
                    ]
                default:
                    return []
            }
        },
        headers() {
            let headers = [
                'ID',
                'TIPO',
                'FOLIO',
                'ENTIDAD FOLIO',
                'ESTADO',
                'MEDIO DE PAGO',
                'TOTAL',
                'MONTO MEDIO DE PAGO',
                'FECHA COBRO',
                'FECHA/HORA',
                'RUT CLIENTE',
                'RAZON SOCIAL CLIENTE',
                'N° CAJA',
            ]
            headers = headers
                .filter(h => !this.excludeHeaders.includes(h))
                .map(h => {
                    return {
                        text: h,
                        value: h,
                    }
                })
            if (this.showing === 9) {
                return this.headerEntryEgress.map(h => {
                    return {
                        text: h,
                        value: h,
                    }
                })
            }
            if (this.showing === 10) {
                return this.headerGroundSeller
            }
            return headers
        },
        headerEntryEgress() {
            return [
                'ID',
                'NUM CAJA',
                'CAJERO',
                'MOVIMIENTO',
                'MONTO',
                'OBSERVACION',
            ]
        },
        headerGroundSeller() {
            return [
                { text: 'TIPO', value: 'tipo' },
                { text: 'FOLIO', value: 'folio' },
                { text: 'EMISIÓN', value: 'fecha_emision' },
                { text: 'RUT VENDEDOR', value: 'rut_vendedor' },
                { text: 'VENDEDOR', value: 'vendedor' },
                { text: 'RUT CLIENTE', value: 'rut_cliente' },
                { text: 'CLIENTE', value: 'cliente' },
                { text: 'DOC REF', value: 'doc_ref' },
                { text: 'FOLIO REF', value: 'folio_referencia' },
            ]
        },

        ...mapState('SnackbarModalModule', {
            showSnackbar: 'showSnackbar',
            responseConfirm: 'responseConfirm',
        }),
        ...mapGetters('AuthModule', {
            branchOfficeID: 'branchOfficeID',
        }),
    },
    methods: {
        /*
         */
        ...mapActions('MenuesModule', {
            setTitleTopBar: 'setTitleTopBar',
        }),
        // async fetchBranchOfficeData(id) {
        //     let route = process.env.VUE_APP_API_ROUTE + `/g_branch_office/${id}`
        //     let r = await axios.get(route)
        //     this.branchOfficeName = r.data.name
        // },
        formatDate(date) {
            let month = '' + (date.getMonth() + 1)
            let day = '' + date.getDate()
            let year = date.getFullYear()
            if (month.length < 2) month = '0' + month
            if (day.length < 2) day = '0' + day
            return [year, month, day].join('-')
        },
        async fetchData() {
            //this.fetchBranchOfficeData(this.branchOfficeID)
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE + `/pos_sales_summary_report`
            try {
                let response = await axios.post(route, {
                    start_date: this.date,
                    end_date: this.date2,
                    branch_office_id: this.branchOfficeSelected,
                })
                //console.log(response)
                if (response.data.pos_sales_summary_report) {
                    this.items = []
                    this.showSuccessSnack(
                        'No se registran ventas para las fechas indicadas'
                    )
                    return
                }
                this.items = response.data
                this.showSuccessSnack('Reporte cargado exitosamente')
            } catch (e) {
                this.showErrorSnack(e.response.data.message)
            }
        },
        async fetchCreditNoteData() {
            //this.fetchBranchOfficeData(this.branchOfficeID)
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/sl_sale_credit_note_summary_report`
            try {
                let response = await axios.post(route, {
                    start_date: this.date,
                    end_date: this.date2,
                    branch_office_id: this.branchOfficeSelected,
                })
                console.log(response, 'response creditnote')
                if (response.data.sl_sale_credit_note_summary_report) {
                    this.items = []
                    this.showSuccessSnack(
                        'No se registran ventas para las fechas indicadas'
                    )
                    return
                }
                this.items = [...response.data]
                this.showSuccessSnack('Reporte cargado exitosamente')
            } catch (e) {
                this.showErrorSnack(e.response.data.message)
            }
        },
        async fetchEntryAndEgress() {
            //this.fetchBranchOfficeData(this.branchOfficeID)
            this.loading = true
            let route =
                process.env.VUE_APP_API_ROUTE +
                `/pos_cash_movement_summary_report`
            try {
                let response = await axios.post(route, {
                    start_date: this.date,
                    end_date: this.date2,
                    branch_office_id: this.branchOfficeSelected,
                })
                console.log(response, 'response Entry Egress')
                if (response.data.pos_cash_movement_summary_report) {
                    this.items = []
                    this.showSuccessSnack(
                        'No se registran ventas para las fechas indicadas'
                    )
                    return
                }
                this.items = [...response.data]
                this.showSuccessSnack('Reporte cargado exitosamente')
            } catch (e) {
                this.showErrorSnack(e.response.data.message)
            }
        },
        async fetchGroundSeller() {
            return SlGroundSellerSaleCommissionModel
                .where('fecha_emision_min', this.date)
                .where('fecha_emision_max', this.date2)
                //.where('branch_office_id', this.branchOfficeSelected)
                .get()
                .then(this.setFetchItems)
                .then(() => {
                    this.showSuccessSnack('Reporte cargado exitosamente')
                })
        },
        setFetchItems(res = {}) {
            this.items = res.data || []
        },
        fetchInformation() {
            switch (this.showing) {
                case 8:
                    this.fetchCreditNoteData()
                    break
                case 9:
                    this.fetchEntryAndEgress()
                    break
                case 10:
                    this.fetchGroundSeller()
                    break
                default:
                    this.fetchData()
                    break
            }
        },
        lowerAndUnderscore(str) {
            return str
                .trim()
                .split(' ')
                .join('_')
                .toLowerCase()
        },
        getTitle(office_name) {
            let date = this.date
            if (this.date !== this.date2) date += `_AL_${this.date2}`
            let title = `REPORTE_VENTA_${
                this.reportName
            }_${office_name}_${date}.xlsx`
            return title
        },
        showExcel(reportModel) {
            return reportModel
                .showFile()
        },
        getXLSX() {
            if (this.showing == 10) {
                let title = this.getTitle(this.branchOfficeName.toUpperCase() || '')
                let reportModel = new SlGroundSellerSaleCommissionModel({ id: 'excel' })
                reportModel
                    .excel('')
                    .then(reportModel.showFile(`${title}`, 'xlsx'))
                return 
                    
            }
            let sheet = XLSX.utils.json_to_sheet(
                this.printData.data,
                this.printData.cols
            )
            console.log(this.printData.data)
            var new_workbook = XLSX.utils.book_new()
            XLSX.utils.book_append_sheet(new_workbook, sheet, 'SheetJS')
            let title = this.getTitle(this.branchOfficeName.toUpperCase() || '')
            XLSX.writeFile(new_workbook, `${title}.xlsx`)
        },
        auth: async function() {
            this.loading = true
            let response = await this.authorize()
            if (response.is_authorized) {
                this.showList = true
                this.loading = false
            } else {
                this.$router.push('/')
            }
        },
        showWaitingSnack(text) {
            this.resetSnackbarState()
            let payloadSnack = this.fillSnack(
                'info',
                text,
                'Espere un momento',
                true
            )
            this.initSnackbar(payloadSnack)
        },
        showSuccessSnack(text) {
            this.resetSnackbarState()
            let payload = {
                typeMessage: 'success',
                message: {
                    title: 'Éxito',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        showErrorSnack(text) {
            let payload = {
                typeMessage: 'error',
                message: {
                    title: 'Error',
                    body: text,
                },
                timeout: 6000,
                showProgress: false,
                showCloseBtn: true,
                closeBtnMessage: 'cerrar',
            }
            this.initSnackbar(payload)
        },
        ...mapActions('SnackbarModalModule', {
            initSnackbar: 'initSnackbar',
            hideSnack: 'hideSnack',
            resetSnackbarState: 'resetSnackbarState',
            setMessageConfirmSnack: 'setMessageConfirmSnack',
        }),
        // ...mapActions('UniqueKeyModule', {
        //     authorize: 'authorize',
        //     setPermission: 'setPermission',
        //     setUniqueKey: 'setUniqueKey',
        // }),
    },
    components: {},
    watch: {
        loading(val) {
            if (val) {
                this.showWaitingSnack('Cargando datos, espere un momento')
            } else {
                this.hideSnack()
            }
        },
        /*
         */
        branchOfficeSelected: {
            deep: true,
            handler(val) {
                let branch = this.branchOfficeList.find(b => b.id === val)
                this.branchOfficeName = branch.name
            },
        },
    },
    async created() {
        this.date = this.formatDate(new Date())
        this.date2 = this.formatDate(new Date())
        this.branchOfficeList = await BranchOfficeService.fetchAll()
        this.branchOfficeSelected = this.branchOfficeID //from vuex
        this.fetchData()
    },
    beforeMount: function() {
        this.setTitleTopBar('Reportes')
    },
}
